<template>
	<!--nav>
	</nav-->
	<div id="app">
		<v-app >
			<v-main>
				<router-view :key="componentKey"/>
			</v-main>
		
		</v-app>

	</div>
</template>
<script>
	import {defineComponent} from 'vue'
	//import AppHeader from './components/header.vue'
	//import AppDrawer from './components/drawer.vue'
	//import AppFooter from './components/footer.vue'
	export default defineComponent({
	name: 'App',
	components :{

		},
	data: () => ({
			key:0,
			componentKey:0
		}),
	computed: {
		
		},
	})
</script>
<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	color: #2c3e50;
}

nav {
	padding: 1px;
}

nav a {
	font-weight: bold;
	color: rgb(var(--v-theme-primary))
}

nav a.router-link-exact-active {
	color: #42b983;
}
</style>
